import { InjectionToken } from '@angular/core';

export const ACTIVITY_INDICATOR_CONFIGURATION = new InjectionToken<ActivityIndicatorConfiguration>('activityIndicatorConfiguration');

export interface ActivityIndicatorConfiguration {
  loadIndicatorClass: string;
  cursorClass: string;
}
